/** 解析後端 Enum（字串或 { name / code / value }） */
export function resolveEnumValue(value) {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'object') {
    return value.name || value.code || value.value || '';
  }
  return String(value);
}

export function formatFundAmount(value, digits = 4) {
  if (value == null || value === '') {
    return (0).toFixed(digits);
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toFixed(digits);
}

export function formatSignedFundAmount(value, digits = 4) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return formatFundAmount(value, digits);
  }
  const formatted = Math.abs(num).toFixed(digits);
  if (num > 0) {
    return formatted;
  }
  if (num < 0) {
    return `-${formatted}`;
  }
  return formatted;
}

export function getAmountTone(value) {
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) {
    return 'neutral';
  }
  return num > 0 ? 'positive' : 'negative';
}

export function tf(t, key, params = {}) {
  let text = t(key);
  Object.entries(params).forEach(([k, v]) => {
    text = text.replaceAll(`{${k}}`, String(v));
  });
  return text;
}

export function formatPaymentStatusLabel(t, status) {
  const code = resolveEnumValue(status);
  if (!code) {
    return t('common.dash');
  }
  const label = t(`funds.paymentStatus.${code}`);
  return label === `funds.paymentStatus.${code}` ? code : label;
}

/** 支付／提現狀態色調：成功綠、待處理橘、失敗紅 */
export function getPaymentStatusTone(status) {
  const code = resolveEnumValue(status).toUpperCase();
  if (code === 'SUCCESS') {
    return 'success';
  }
  if (code === 'WAITING_CALLBACK' || code === 'PROCESSING' || code === 'PENDING') {
    return 'pending';
  }
  if (code === 'REJECT' || code === 'FAIL' || code === 'TIMEOUT' || code === 'EXCEPTION') {
    return 'danger';
  }
  return 'neutral';
}

export function formatTransactionTypeLabel(t, type) {
  const code = resolveEnumValue(type);
  if (!code) {
    return t('common.dash');
  }
  const label = t(`funds.transactionType.${code}`);
  return label === `funds.transactionType.${code}` ? code : label;
}

export function formatDepositTypeLabel(t, type) {
  const code = resolveEnumValue(type);
  if (!code) {
    return t('common.dash');
  }
  const label = t(`funds.depositType.${code}`);
  return label === `funds.depositType.${code}` ? code : label;
}

export function sumWalletFields(wallet) {
  const balance = Number(wallet?.balance) || 0;
  const frozen = Number(wallet?.frozenBalance) || 0;
  const flowFrozen = Number(wallet?.flowFrozenBalance) || 0;
  const locked = Number(wallet?.toReleased) || 0;
  return {
    total: balance + frozen + flowFrozen + locked,
    available: balance,
    frozen: frozen + flowFrozen,
    locked,
    withdrawalStats: flowFrozen,
    coinName: wallet?.coinName || 'USDT',
  };
}
